import { Outlet } from 'react-router';
import { useMemo } from 'react'
import useCustomizeTheme from 'hooks/useCustomizeTheme';
import useConfiguration from 'hooks/useConfiguration';
import React from 'react'
const FullLayout = () => {
    const { handleChangeTheme } = useCustomizeTheme()
    const { handleConfiguration } = useConfiguration()

    useMemo(() => {
        handleChangeTheme(localStorage.getItem('theme') ?? 'white')
        handleConfiguration(localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config') as string) : {})
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const bigCircle: React.CSSProperties = {
        position: "absolute",
        // zIndex: '0',
        top: -30,
        right: 0,
        borderRadius: '50% 0px 0px 50%',
        background: 'linear-gradient(30deg, #1BA5A9 10%, #ffffff 99.99%, #ffffff 100%)',
        height: '150vh',
        width: '50vw',
        overflow: 'hidden'
    }
    const smallCircle: React.CSSProperties = {
        position: "absolute",
        // zIndex: '1',
        top: -300,
        left: -450,
        borderRadius: '50% 50% 50% 50%',
        background: 'linear-gradient(30deg, #1BA5A9 10%, #ffffff 99.99%, #ffffff 100%)',
        height: '70vh',
        width: '40vw',
        overflow: 'hidden'
    }
    const line1: React.CSSProperties = {
        position: "absolute",
        // zIndex: '1',
        top: -30,
        right: 25,
        borderRadius: '50% 0px 0px 50%',
        background: 'transparent',
        borderTop: '1px solid #BFC7DF',
        borderLeft: '1px solid #BFC7DF',
        height: '150vh',
        width: '50vw',
        overflow: 'hidden'
    }
    const line2: React.CSSProperties = {
        position: "absolute",
        // zIndex: '1',
        top: -30,
        right: 33,
        borderRadius: '50% 0px 0px 50%',
        background: 'transparent',
        borderTop: '1px solid #DFE4F0',
        borderLeft: '1px solid #DFE4F0',
        height: '150vh',
        width: '50vw',
        overflow: 'hidden'
    }
    const line3: React.CSSProperties = {
        position: "absolute",
        // zIndex: '1',
        top: -350,
        left: -380,
        borderRadius: '50% 50% 50% 50%',
        background: 'transparent',
        border: '1px solid #BFC7DF',
        height: '70vh',
        width: '40vw',
        overflow: 'hidden'
    }
    return (
        <div className="bg-primary-main w-full h-screen overflow-hidden relative">
            <div style={bigCircle}></div>
            <div style={smallCircle}></div>
            <div style={line1}></div>
            <div style={line2}></div>
            <div style={line3}></div>
            <Outlet />
        </div>
    )
}

export default FullLayout
